<template>
  <div class="form-wizard">
    <WizardSteps :current-step="currentStepNumber" :steps="steps" />

    <div class="form-wizard-main">
      <Gallery ref="gallery" v-if="displayGallery" @on-select="provideSelection" />
      <component :is="currentStep" ref="currentStepComponent" @open-gallery-fullscreen="openGalleryFullscreen" />
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, computed, ref } from 'vue'

import useFormWizard from '@/hooks/formWizard'
import useFormState from '@/hooks/formState'
import useBreakpoint from '@/hooks/useBreakpoint'

import { LANGUAGE_CONFIG } from '@/services/language'

import WizardSteps from '@/components/Global/WizardSteps'
import RoofType from '@/components/Calculator/Steps/RoofType'
import Measurements from '@/components/Calculator/Steps/Measurements'
import TileShape from '@/components/Calculator/Steps/TileShape'
import Tiles from '@/components/Calculator/Steps/Tiles'
import SummaryStep from '@/components/Calculator/Steps/Summary'
import Package from '@/components/Calculator/Steps/Package'
import Gallery from '@/components/Global/Gallery'
import Questions from '@/components/Calculator/Steps/Questions'

export default defineComponent({
  name: 'HomeView',
  components: {
    WizardSteps,
    RoofType,
    Measurements,
    TileShape,
    Tiles,
    SummaryStep,
    Gallery,
    Package,
    Questions
  },
  setup() {
    const { currentStep, currentStepNumber, currentStepComponent, setSteps, isLastStep, goToStep } = useFormWizard()
    const { updateFormState } = useFormState()
    const currentLanguage = localStorage.getItem('language') || process.env.VUE_APP_DEFAULT_LOCALE
    const { isMobile } = useBreakpoint()

    const steps = LANGUAGE_CONFIG[currentLanguage].steps

    const gallery = ref(null)

    const galleryConfig = {
      TileShape: { mobile: false },
      Tiles: { mobile: true }
    }

    const displayGallery = computed(() => {
      const config = galleryConfig[currentStep.value]

      if (!config) return false

      if (isMobile.value) {
        return config.mobile
      }

      return true
    })

    const provideSelection = item => {
      if (['Tiles'].includes(currentStep.value)) {
        currentStepComponent.value.updateState(item)
      }
    }

    const openGalleryFullscreen = () => {
      gallery.value.toggleFullscreen()
    }

    const url = new URL(window.location.href)
    const stepParam = url.searchParams.get('step')
    const storedFormState = JSON.parse(localStorage.getItem('tc_form'))

    if (stepParam && storedFormState) {
      updateFormState({ ...storedFormState })
      goToStep(stepParam)
    }

    onMounted(() => setSteps(steps))

    return {
      currentStep,
      currentStepNumber,
      currentStepComponent,
      steps,
      isLastStep,
      displayGallery,
      provideSelection,
      gallery,
      openGalleryFullscreen
    }
  }
})
</script>
